import { API_ENDPOINTS } from './constants';

export async function fetchBlockchairStats(coin: string) {
  try {
    const response = await fetch(`${API_ENDPOINTS.BLOCKCHAIR}/${coin.toLowerCase()}/stats`);
    
    if (!response.ok) {
      throw new Error(`Blockchair API responded with status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (!data.data) {
      throw new Error('Invalid data format received from Blockchair API');
    }
    
    return data.data;
  } catch (error) {
    console.warn('Error fetching Blockchair stats:', error);
    return null;
  }
}